// SPDX-FileCopyrightText: 2022 Dusan Mijatovic (dv4all)
// SPDX-FileCopyrightText: 2022 dv4all
// SPDX-FileCopyrightText: 2023 - 2025 Dusan Mijatovic (Netherlands eScience Center)
// SPDX-FileCopyrightText: 2023 - 2025 Netherlands eScience Center
// SPDX-FileCopyrightText: 2025 Ewan Cahen (Netherlands eScience Center) <e.cahen@esciencecenter.nl>
//
// SPDX-License-Identifier: Apache-2.0

import {useContext} from 'react'

import {LoginProvidersContext} from '~/auth/loginProvidersContext'

export default function useLoginProviders(){
  const {providers,setProviders} = useContext(LoginProvidersContext)

  return {
    providers,
    setProviders
  }
}
